import * as React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { ListItem } from './ListItem';
import { ListItemIcon } from './ListItemIcon';
import { ListItemText } from './ListItemText';

export type OwnProps = {
  inset?: boolean;
  icon?: JSX.Element;
  tooltip?: boolean;
  divider?: boolean;
};

export type Props = OwnProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const AnchorListItem: React.FC<Props> = ({ inset, icon, tooltip, divider, children, ...anchorProps }) => {
  const Link = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, Props>((props, ref) => (
        <a ref={ref} {...props} {...anchorProps}>
          {icon && <ListItemIcon>{icon}</ListItemIcon>}
          <ListItemText
            inset={inset}
            primaryTypographyProps={{
              noWrap: true
            }}
          >
            {props.children}
          </ListItemText>
        </a>
      )),
    [anchorProps, icon, inset]
  );

  const listItem = (
    <ListItem button divider={divider} component={Link}>
      {children}
    </ListItem>
  );

  return tooltip ? (
    <Tooltip title={<React.Fragment>{children}</React.Fragment>} placement="right">
      {listItem}
    </Tooltip>
  ) : (
    listItem
  );
};
